import { Grid as Base, GridProps as Props } from "@chakra-ui/react";
import React from 'react';

export function Grid(props: Props) {
    return <Base {...props}/>
}

export default Grid